import { getApiBaseUrl, authenticatedFetch } from './api';

export const MEMORY_UPDATED_EVENT = 'kai-memory-updated';

const CONSOLIDATE_INTERVAL_MS = 7 * 24 * 60 * 60 * 1000;
const LAST_RUN_PREFIX = 'kai_memory_consolidate_last_run_';
const ENABLED_KEY = 'kai_memory_auto_consolidate_enabled';

const AUTO_TYPES = ['fact', 'preference', 'rule'];

export function getUserIdForSchedule(user) {
  return user?.id || user?.user_id || '';
}

export function isAutoConsolidateEnabled() {
  const value = localStorage.getItem(ENABLED_KEY);
  if (value === null) return true;
  return value !== 'false';
}

export function setAutoConsolidateEnabled(enabled) {
  localStorage.setItem(ENABLED_KEY, enabled ? 'true' : 'false');
}

export function isWeeklyConsolidateDue(userId) {
  if (!userId) return false;
  const raw = localStorage.getItem(`${LAST_RUN_PREFIX}${userId}`);
  if (!raw) return true;
  const last = Date.parse(raw);
  if (Number.isNaN(last)) return true;
  return Date.now() - last >= CONSOLIDATE_INTERVAL_MS;
}

export function markWeeklyConsolidateRun(userId) {
  if (!userId) return;
  localStorage.setItem(`${LAST_RUN_PREFIX}${userId}`, new Date().toISOString());
}

/**
 * Run silent weekly consolidation for all semantic types when due.
 * Returns { ran, totalDeleted }.
 */
export async function runWeeklyMemoryConsolidateIfDue(userId) {
  if (!userId || !isAutoConsolidateEnabled() || !isWeeklyConsolidateDue(userId)) {
    return { ran: false, totalDeleted: 0 };
  }

  markWeeklyConsolidateRun(userId);

  let totalDeleted = 0;
  for (const type of AUTO_TYPES) {
    try {
      const res = await authenticatedFetch(`${getApiBaseUrl()}/memory/consolidate/auto`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type }),
      });
      if (!res.ok) continue;
      const body = await res.json();
      if (body.applied && body.stats) {
        totalDeleted += body.stats.deleted || 0;
      }
    } catch (err) {
      console.warn('Weekly memory consolidate failed for', type, err);
    }
  }

  if (totalDeleted > 0) {
    window.dispatchEvent(
      new CustomEvent(MEMORY_UPDATED_EVENT, { detail: { totalDeleted } })
    );
  }

  return { ran: true, totalDeleted };
}
